import styled from 'styled-components';

export const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    flex-direction: row;
    gap: 24px;
  }
`;

export const Card = styled.button`
  position: relative;
  width: 100%;
  border-radius: 16px;
  padding: 16px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  min-height: 200px;
  overflow: hidden;
  border: none;
  text-align: left;
  align-items: flex-start;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow:
    0px 0px 0px 1px ${({ theme }) => theme.colors.neutral.lavenderLight},
    0px 1px 1px 0px rgba(67, 71, 146, 0.12);
  transition:
    background 0.2s ease,
    box-shadow 0.2s ease;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    flex: 1;
  }

  &:hover {
    background: linear-gradient(to right, rgba(249, 225, 104, 0.48), rgba(249, 225, 104, 0.48));
    box-shadow: ${({ theme }) => theme.shadows.container.glowYellow};
  }
`;

export const CardTitle = styled.h2`
  ${({ theme }) => theme.fonts.DMSerif};
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0.32px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  margin: 0;
  position: relative;
  z-index: 1;
`;

export const CardDescription = styled.p`
  ${({ theme }) => theme.fonts.Satoshi};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  margin: 0;
  flex: 1;
  position: relative;
  z-index: 1;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 0;
  right: -0.33px;
  width: 240px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  opacity: 0.24;
  transition: opacity 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CardHoverIconContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 246px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.2s ease;

  svg {
    width: 100%;
    height: 100%;
    object-fit: contain;

    g {
      opacity: 0.56;
    }

    path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }
`;

export const CardWrapper = styled.div`
  position: relative;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    flex: 1;
  }

  &:hover ${IconContainer} {
    opacity: 0;
  }

  &:hover ${CardHoverIconContainer} {
    opacity: 0.56;
  }
`;
